<template>
    <div class="seal-page">
        <!-- 顶部标签切换 -->
        <div class="top_change">
            <div class="l_where">
                企业<span>/</span>印章管理
            </div>
            <div class="middle_width flex-b">
                <div class="nav_name" :class="activeNav === '1' ? 'active' : ''" @click="changeTable('1')">我的印章</div>
                <div class="nav_name" :class="activeNav === '2' ? 'active' : ''" @click="changeTable('2')">待审核印章</div>
            </div>
        </div>

        <!-- 我的印章标签页 -->
        <div v-if="activeNav === '1'">
            <!-- 我的签章/签名 -->
            <!-- <div class="seal-nav">
                <div class="flex">
                    <div class="seal_title">我的签章/签名</div>
                </div>
                <Alert type="warning" show-icon style="margin-top: 12px;">
                    选择上传印章,上传印章图片大小为160*50,图片格式为Png
                </Alert>
                <div class="flex" style="flex-wrap: wrap; gap: 18px; margin-top: 12px;">
                    <div v-for="(item, index) in sealArr" :key="index">
                        <div class="seal_and_signature">
                            <img :src="item.self_signature" style="width: 100%; height: 100%; object-fit: cover;" />
                        </div>
                    </div>
                </div>
            </div> -->

            <!-- 企业印章 -->
            <div class="seal-nav">
                <div class="flex">
                    <div class="seal_title">企业印章</div>
                    <Alert type="warning" show-icon style="margin-top: 12px; margin-left: 24px"
                        v-if="$store.state.identity != 2">选择上传印章,上传印章图片大小为320*320,图片格式为Png</Alert>
                </div>
                <div class="choose_style">
                    <div class="table-btn blue" @click="creatSeal">创建印章</div>
                    <!-- <Upload :show-upload-list="false" :headers='headers' :action="imageAction"
                        :on-format-error="handleFormatError" :on-progress="handleProgress" :format="['jpg', 'jpeg', 'png']"
                        :on-success="uploadImgSuccess" v-if='$store.state.identity == 1 || $store.state.identity == 3'>
                        <div class="table-btn edit">
                            上传印章
                        </div>
                    </Upload> -->
                </div>

                <div class="seal_group">
                    <div class="seal_nav_item" v-for="(item, index) in list" :key="index">
                        <div :class="item.status === 0 ? 'seal-img flex-c' : 'seal-img flex-c haschoose'">
                            <div class="right_top" v-if="item.status !== 0">已使用</div>
                            <img :src="item.seal_path" />
                            <div class="do_it"></div>
                            <div class="do_btn">
                                <div class="l-icons flex-c" @click="seeImg(item.seal_path, '1')">
                                    <i class="iconfont icon-chakan2"></i>
                                </div>
                                <div class="l-icons flex-c" @click="delSeal(item.id)">
                                    <i class="iconfont icon-shanchu"></i>
                                </div>
                            </div>
                        </div>
                        <div class="" style="text-align: center;width: 100%;margin-top: 4px;">
                            <span>{{ item.seal_name }}</span> 
                        </div>
                        <div class="out_height flex-c" style="width: 100%;">
                            <div class="use_btn flex-c"   v-if="item.status === 0" @click="useSeal(item.id)">使用</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- 待审核印章标签页 -->
        <div v-if="activeNav === '2'">
            <div class="page-cont">
                <div class="a-table" style="margin-top:20px">
                    <div class="flex new_switch">
                        <div class="nav_title">公章开关: </div>
                        <div style="margin-left:8px">
                            <i-switch :before-change="handleBeforeChange" v-model="seal_switch" :true-value="1" :false-value="0" size="large">
                                <span slot="open">开启</span>
                                <span slot="close">关闭</span>
                            </i-switch>
                        </div>
                    </div>
                </div>
                <div v-if='seal_switch == 1'>
                    <div class="a-table">
                        <Select v-model="storePrams.status" default-label="审核状态" class="new_select" @on-change='getListSearch'>
                            <Option v-for="item in selectList" :value="item.value" :key="item.value">{{ item.label }}</Option>
                        </Select>
                    </div>
                    <div class="b_table">
                        <Table :columns="platformColumns" :data="storeList" :loading='loadingTab'>
                            <template slot-scope="{ row }" slot="operation">
                                <div class="flex" style="align-items: center;justify-content: center;">
                                    <div v-if="storePrams.status === '0'" class="table-btn blue" @click="agree(row)">同意</div>
                                    <div v-if="storePrams.status === '0'" class="table-btn danger" @click="clearDel(row.id)">拒绝</div>
                                    <Button v-if="storePrams.status === '1'&&row.status === 1" type="error" size='small' @click="goDel(row)">删除</Button>
                                </div>
                            </template>
                            <template slot-scope="{ row }" slot="cont">
                                <div v-if="row.contract_arr != null " class="cont-cla" @click="goSeeCont(row)">{{row.contract_arr.contract_name}}</div>
                            </template>
                            <template slot-scope="{ row }" slot="status">
                                <div>{{row.status === 0 ? '待审核' : row.status === 1 ? '审核成功' : row.status === 2 ?  '审核失败' : ''}}</div>
                            </template>
                            <template slot-scope="{ row }" slot="account">
                                <div @click="openImg(row.seal_id.seal_img)" v-if="row.seal_id?row.seal_id.seal_content:false" style="cursor:pointer;">{{row.seal_id.seal_content}}</div>
                                <img @click="openImg(row.seal_id.seal_img)" :src="row.seal_id.seal_img" v-else style="cursor:pointer;width:50px;height:50px">
                            </template>
                            <template slot-scope="{ row }" slot="real_name">
                                <div>{{row.user_id?row.user_id.real_name:''}}</div>
                            </template>
                            <template slot-scope="{ row }" slot="admin">
                                <div>{{row.user_id?row.user_id.account:''}}</div>
                            </template>
                        </Table>
                        <br/>
                        <Page :total="storePrams.total"
                            :current="storePrams.page"
                            style="text-align:right"
                            show-elevator show-total
                            @on-change="pageChange"
                            :page-size="storePrams.limit"/>
                    </div>
                </div>
            </div>
        </div>

        <!-- 确认印章上传提示框 -->
        <div v-if="showSeal">
            <div class="pop"></div>
            <div class="seal_card fixed flex-c">
                <Icon type="md-close" size="30" @click="closeImg" class="close" />
                <div class="require_seal">
                    <img :src="showPic">
                </div>
                <Button type="primary" v-if="justSee" style="margin-top: 20px" @click="checkUp">确认上传</Button>
            </div>
        </div>

        <!-- CA创建印章弹出层 -->
        <Modal title="创建印章" v-model="showModal" width="600" :styles="{ top: '20%' }" :mask-closable="false">
            <div style="width:100%;">
                <div class="flex one_input" style="margin-left:100px">
                    印章类型：
                    <Select v-model="newCaSeal.qysseal_type" style="width:200px;" @on-change="goCaChange">
                        <Option v-for="i in newType" :value="i.id" :key="i.id">{{ i.name }}</Option>
                    </Select>
                </div>
                <div class="flex one_input" style="margin-left:100px">
                    横排文字：<Input style="width: 250px" v-model="newCaSeal.strname" placeholder="请输入横排文字"></Input>
                </div>
                <div class="flex one_input" style="margin-left:100px" v-if="newCaSeal.qysseal_type != 2">
                    企业编码：<Input style="width: 250px" v-model="newCaSeal.strnumber" placeholder="请输入企业编码"></Input>
                </div>
            </div>
            <div class="fenbu" slot="footer">
                <Button @click="showModal = false" class="">取 消</Button>
                <Button @click="goCaSubmit" type="primary" class="">确认</Button>
            </div>
        </Modal>

        <!-- 非ca印章创建 -->
        <Modal title="创建印章" v-model="showYz" width="700" :styles="{ top: '20%' }" :mask-closable="false">
            <div class='flex'>
                <div style="width:350px;height:310px">
                    <div class="flex one_input" v-if="$store.state.identity == 1 || $store.state.identity == 3">
                        <div class="text_red" style="width:6px">*</div>公司名称：
                        <Input style="width: 200px"
                            v-model="seal.str" placeholder="请输入公司名称" :disabled="true"></Input>
                        <Tooltip placement="bottom">
                            <Icon type="ios-help-circle-outline" size='20' class="icon-cla" style="margin-left:8px" />
                            <div slot="content" style="font-size:12px;white-space: normal;max-width:400px">
                                <p>公司名称最少五个字,少于五个字不生成印章</p>
                            </div>
                        </Tooltip>
                    </div>
                    <div class="flex one_input">
                        <div class="text_red" style="width:6px">*</div>印章名称：
                        <Input style="width: 200px"
                            v-model="seal.seal_name" placeholder="请输入印章名称"></Input>
                    </div>
                    <div class="flex one_input">
                        <div class="text_red" style="width:6px"></div>企业编码：<Input style="width: 200px"
                            v-model="seal.strnumber" placeholder="请输入企业编码"></Input>
                    </div>
                    <div class="flex one_input">
                        <div class="text_red" style="width:6px"></div>印章类型：<Input style="width: 200px"
                            v-model="seal.strname" maxlength='7' placeholder="请输入印章类型"></Input>
                        <Tooltip placement="bottom">
                            <Icon type="ios-help-circle-outline" size='20' class="icon-cla" style="margin-left:8px" />
                            <div slot="content" style="font-size:12px;white-space: normal;max-width:400px">
                                <p>印章类型最多七个字</p>
                            </div>
                        </Tooltip>
                    </div>

                    <!-- 添加仿真开关 -->
                    <div class="flex one_input">
                        <div class="text_red" style="width:6px"></div>
                        开启仿真：
                        <i-switch v-model="simulation" @on-change="isCanShow"
                            style="width:40px;margin-left:10px"></i-switch>
                        <Tooltip placement="bottom">
                            <Icon type="ios-help-circle-outline" size='20' class="icon-cla" style="margin-left:8px" />
                            <div slot="content" style="font-size:12px;white-space: normal;max-width:400px">
                                <p>开启后印章将显示仿真效果，更接近实物印章</p>
                            </div>
                        </Tooltip>
                        <div v-if="simulation" style="margin-left: 10px;">
                            <Button type="primary" size="small" @click="addAgingEffect">做旧</Button>
                            <Button type="primary" size="small" style="margin-left: 10px;"
                                @click="addSmearEffect">拖影</Button>
                            <Button size="small" style="margin-left: 10px;" @click="goUp">重置</Button>
                        </div>
                    </div>
                </div>
                <!-- 印章预览 -->
                <div>
                    <div class="yz_cla">
                        <div><canvas id="my_canvas" width="320px" height="320px"></canvas></div>
                    </div>
                    <!-- <div class="yulan">印章预览</div> -->
                    <div class="yulan" style="max-width: 320px;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;">{{ seal.seal_name || '印章名称' }}</div>
                    <!-- <div class="yulan" style="margin-top: 8px; color: #515a6e; font-size: 14px;" v-if="seal.seal_name">
                        {{ seal.seal_name }}
                    </div> -->
                </div>
            </div>
            <div class="fenbu" slot="footer">
                <Button @click="showYz = false" class="">取 消</Button>
                <Button @click="submit" type="primary" class="">确认</Button>
            </div>
        </Modal>

        <!-- 拒绝申请弹窗 -->
        <Modal
            title="拒绝申请"
            v-model="showMsg"
            @on-ok="requireMsg"
            :mask-closable="false">
            <div class="input_wrap">
                <div class="wrap_label">拒绝原因:</div>
                <div class="wrap-inp">
                    <Input v-model="refuse_reason" type="textarea" :rows="4" placeholder="请输入拒绝原因" style="width: 400px" />
                </div>
            </div>
        </Modal>

        <!-- 同意申请弹窗 -->
        <Modal
            title="同意申请"
            v-model="showMore"
            @on-ok="requireMore"
            :mask-closable="false">
            <div class="agree_require">
                <div class="wrap_label">短信提醒</div>
                <div style="margin-left: 16px;">
                    <i-switch size="large" v-model="is_sms" :value="is_sms" :true-value="1" :false-value="0">
                        <span slot="open">开启</span>
                        <span slot="close">关闭</span>
                    </i-switch>
                </div>
            </div>
        </Modal>
    </div>
</template>

<script>
import { getCookies } from '@/utils/helper'
import config from '@/config/index'
import { seal_list } from '@/api/tang'
import { comCreateSeal } from '@/utils/yinzhang'
import { applyVintageMask, smear } from '@/utils/yinzhang'
import { addImgsseal, seallist, editstamp, deleteStamp, stampaddsign, get_enterprise_info } from '@/api/interFace'
import { examineList, examineSeal, del_applyrecord, get_sealstatus, apply_switch } from '@/api/interFace'

export default {
    name: 'enterprise-seal',
    data() {
        return {
            activeNav: '1', // 当前激活的标签页
            imageAction: config.apiUrl + '/adminapi/common/sigin_uploads',
            headers: { 'Authori-zation': getCookies('token') },
            list: [],
            sealArr: [],
            showSeal: false,
            justSee: true,
            showModal: false,
            showYz: false,
            simulation: false,
            showPic: '',
            relative_path: '',
            seal: {
                type: 1,
                str: '',
                strnumber: '',
                strname: '',
                qysseal_type: '',
                seal_imgs: "",
                seal_name: '', // 印章名称
                enterprise_auth_id: '' // 认证企业ID
            },
            enterpriseInfo: {}, // 企业信息
            newCaSeal: {
                type: 1,
                str: '',
                strnumber: '',
                strname: '',
                qysseal_type: '',
                seal_imgs: ""
            },
            newType: [
                { id: 1, name: '公章' },
                { id: 2, name: '专用章' }
            ],
            // 待审核印章相关
            selectList: [
                { value: '0', label: "待审核" },
                { value: '1', label: "审核完成" },
            ],
            seal_switch: 0,
            platformColumns: [
                {
                    title: '#',
                    key: 'id',
                    width: 80,
                    align: 'center'
                },
                {
                    title: '用户姓名',
                    slot: 'real_name',
                    align: 'center'
                },
                {
                    title: '申请账户',
                    slot: 'admin',
                    align: 'center'
                },
                {
                    title: '印章名称',
                    slot: 'account',
                    align: 'center'
                },
                {
                    title: '合同名称',
                    key: 'contract_id',
                    slot: 'cont',
                    align: 'center'
                },
                {
                    title: '使用次数',
                    key: 'seal_num',
                    align: 'center',
                    width: 120,
                },
                {
                    title: '申请原因',
                    key: 'apply_reason',
                    align: 'center'
                },
                {
                    title: '申请状态',
                    key: 'status',
                    slot: 'status',
                    align: 'center'
                },
                {
                    title: '拒绝原因',
                    key: 'refuse_reason',
                    align: 'center'
                },
                {
                    title: '申请时间',
                    key: 'created_at',
                    width: 200,
                    align: 'center'
                },
                {
                    title: '操作',
                    key: 'action',
                    width: 200,
                    fixed: 'right',
                    align: 'center',
                    slot: 'operation'
                }
            ],
            storeList: [],
            loadingTab: false,
            showMsg: false,
            showMore: false,
            storePrams: {
                limit: 10,
                page: 1,
                total: 0,
                status: '0'
            },
            refuse_reason: '',
            needId: '',
            is_sms: 1,
            msgID: ''
        }
    },
    created() {
        this.getlist()
        // this.getSealList()
        if (this.activeNav === '2') {
            this.getList()
            this.get_sealstatus()
        }
    },
    watch: {
        get_seal_str: {
            handler: function () {
                this.isCanShow()
            },
        },
        get_seal_strname: {
            handler: function () {
                this.isCanShow()
            },
        },
        get_seal_strnumber: {
            handler: function () {
                this.isCanShow()
            },
        },
        get_seal_qysseal_type: {
            handler: function () {
                this.isCanShow()
            },
        },
    },
    computed: {
        get_seal_str: function () {
            return this.seal.str
        },
        get_seal_strname: function () {
            return this.seal.strname
        },
        get_seal_strnumber: function () {
            return this.seal.strnumber
        },
        get_seal_qysseal_type: function () {
            return this.seal.qysseal_type
        },
    },
    methods: {
        // 切换标签页
        changeTable(nav) {
            this.activeNav = nav
            if (nav === '2') {
                this.getList()
                this.get_sealstatus()
            }
            if(nav === '1') {
                this.getlist()
            }
        },
        // 获取签章/签名列表
        getSealList() {
            seal_list().then(res => {
                this.sealArr = res.data
            }).catch(res => {
                this.$Message.error(res.msg)
            })
        },
        // 获取企业印章列表
        getlist() {
            seallist({ type: '1', enterprise_auth_id: localStorage.getItem('enterprise_auth_id') || '' }).then(async res => {
                this.list = res.data;
            }).catch(res => {
                console.log(res)
                this.list = [];
            })
        },
        // 创建印章
        creatSeal() {
            this.removeData()
            // 获取企业信息
            this.getEnterpriseInfo()
            this.showYz = true
            // if (this.$store.state.identity == 1 || this.$store.state.identity == 3) {
            // } else {
            //     this.showModal = true
            // }
        },
        // 获取企业信息
        getEnterpriseInfo() {
            get_enterprise_info({ enterprise_auth_id: this.seal.enterprise_auth_id || localStorage.getItem('enterprise_auth_id') || '' }).then(res => {
                if (res.code === 200 && res.data && res.data.enterprise_info) {
                    const enterpriseInfo = res.data.enterprise_info
                    this.enterpriseInfo = enterpriseInfo
                    // 设置公司名称（只读）
                    this.seal.str = enterpriseInfo.prise_name || ''
                    // 设置认证企业ID
                    this.seal.enterprise_auth_id = enterpriseInfo.id || ''
                }
            }).catch(err => {
                this.$Message.error(err.msg || '获取企业信息失败')
            })
        },
        // 清空数据
        removeData() {
            this.seal.str = ''
            this.seal.strnumber = ''
            this.seal.qysseal_type = ''
            this.seal.strname = ''
            this.seal.seal_name = ''
            this.seal.enterprise_auth_id = ''
            this.simulation = false
            this.gocanva()
        },
        // 提交非CA印章
        submit() {
            if (this.seal.str == '') return this.$Message.error('请填写公司名称')
            if (!(this.seal.str.length > 4)) return this.$Message.error('公司名称不能少于五个字')
            if (!this.seal.seal_name) return this.$Message.error('请输入印章名称')
            if (!this.seal.enterprise_auth_id) return this.$Message.error('企业信息获取失败，请刷新重试')
            let pageData = document.getElementById("my_canvas").toDataURL("image/png");
            this.seal.seal_imgs = pageData
            const submitData = {
                ...this.seal,
                enterprise_auth_id: this.seal.enterprise_auth_id,
                seal_name: this.seal.seal_name
            }
            stampaddsign(submitData).then(async res => {
                this.$Message.success(res.msg)
                this.showYz = false
                this.seal.seal_imgs = ''
                this.getlist()
            }).catch(res => {
                this.$Message.error(res.msg)
            })
        },
        // 做旧效果
        addAgingEffect() {
            const canvas = document.getElementById("my_canvas");
            applyVintageMask({ canvas });
        },
        // 拖影效果
        addSmearEffect() {
            const canvas = document.getElementById("my_canvas");
            smear({ canvas });
        },
        // 重置画布
        goUp() {
            let c = document.getElementById("my_canvas");
            let cxt = document.getElementById("my_canvas").getContext("2d");
            c.height = document.getElementById("my_canvas").height;
            comCreateSeal({ 
                canvas: document.getElementById("my_canvas"), 
                company: this.seal.str, 
                name: this.seal.strname, 
                number: this.seal.strnumber, 
                companyTight: false, 
                simulation: this.simulation 
            });
        },
        // 判断是否可以显示
        isCanShow() {
            if (this.$store.state.identity == 1 || this.$store.state.identity == 3) {
                if (this.seal.str.length > 4) {
                    this.gocanva()
                } else {
                    let c = document.getElementById("my_canvas");
                    let cxt = document.getElementById("my_canvas").getContext("2d");
                    c.height = document.getElementById("my_canvas").height;
                    comCreateSeal({ 
                        canvas: document.getElementById("my_canvas"), 
                        company: '', 
                        name: '', 
                        number: '', 
                        companyTight: false, 
                        simulation: this.simulation 
                    });
                }
            }
        },
        // 绘制canvas
        gocanva() {
            let c = document.getElementById("my_canvas");
            let cxt = document.getElementById("my_canvas").getContext("2d");
            c.height = document.getElementById("my_canvas").height;
            comCreateSeal({ 
                canvas: document.getElementById("my_canvas"), 
                company: this.seal.str, 
                name: this.seal.strname, 
                number: this.seal.strnumber, 
                companyTight: false, 
                simulation: this.simulation 
            });
        },
        // CA印章类型改变
        goCaChange(e) {
            if (e == 1) {
                this.newCaSeal.strname = '公章'
            } else {
                this.newCaSeal.strname = '专用章'
            }
        },
        // CA提交
        goCaSubmit() {
            if (this.newCaSeal.qysseal_type == '') {
                return this.$Message.error('请选择公章类型')
            }
            stampaddsign(this.newCaSeal).then(async res => {
                this.$Message.success(res.msg)
                this.showModal = false
                this.getlist()
                this.newCaSeal.strname = ''
                this.newCaSeal.qysseal_type = ''
                this.newCaSeal.strnumber = ''
            }).catch(res => {
                this.$Message.error(res.msg)
            })
        },
        // 查看图片
        seeImg(path) {
            this.showPic = path
            this.showSeal = true
            this.justSee = false
        },
        // 删除印章
        delSeal(id) {
            this.$Modal.confirm({
                title: '删除提示',
                content: '请问您是否确认删除此印章，删除后无法恢复！！！',
                onOk: () => {
                    deleteStamp({ id: id }).then(async res => {
                        this.getlist()
                        this.$Message.success(res.msg)
                    }).catch(res => {
                        this.$Message.error(res.msg)
                    })
                },
                onCancel: () => {
                }
            });
        },
        // 使用印章
        useSeal(id) {
            editstamp({ id: id }).then(async res => {
                this.getlist()
                this.$Message.success(res.msg)
            }).catch(res => {
                this.$Message.error(res.msg)
            })
        },
        // 确认上传
        checkUp() {
            addImgsseal({ seal_path: this.relative_path, type: '1' }).then(res => {
                this.$Message.success(res.msg);
                this.showSeal = false
                this.getlist()
            }).catch(res => {
                this.$Message.error(res.msg);
            })
        },
        // 关闭图片预览
        closeImg() {
            this.showPic = ''
            this.relative_path = ''
            this.showSeal = false
        },
        // 上传进度
        handleProgress() {
            const msg = this.$Message.loading({
                content: '上传中...',
                duration: 0
            });
            setTimeout(msg, 3000);
        },
        // 上传成功
        uploadImgSuccess(e) {
            this.showPic = e.data.src
            this.relative_path = e.data.relative_path
            this.showSeal = true
            this.$Message.destroy()
            if (e.code == 400) {
                this.$Message.error(e.msg)
                this.showSeal = false
            } else {
                this.$Message.success(e.msg);
            }
        },
        // 文件格式错误
        handleFormatError() {
            this.$Message.warning('暂不支持上传此格式');
        },
        // 待审核印章相关方法
        openImg(e) {
            this.$Modal.info({
                title: '预览图片',
                content: '<img style="width:250px;height:250px" src="' + e + '" />'
            });
        },
        get_sealstatus() {
            this.$store.commit('changePollingSpin', true)
            get_sealstatus({ enterprise_auth_id: localStorage.getItem('enterprise_auth_id') || '' }).then(res => {
                this.seal_switch = res.data.seal_switch
                this.$store.commit('changePollingSpin', false)
            })
        },
        getList() {
            this.loadingTab = true
            examineList(this.storePrams).then(res => {
                this.loadingTab = false
                this.storeList = res.data.data || []
                this.storePrams.total = res.data.total
            })
        },
        getListSearch(e) {
            this.storePrams.page = 1
            this.getList()
        },
        handleBeforeChange() {
            return new Promise((resolve) => {
                this.$Modal.confirm({
                    title: '切换确认',
                    content: '您确认要切换开关状态吗？',
                    onOk: () => {
                        apply_switch({ status: this.seal_switch == 0 ? 1 : 0 }).then(res => {
                            this.$Message.success(res.msg)
                            this.get_sealstatus()
                        }).catch(res => {
                            this.$Message.error(res.msg)
                        })
                        resolve();
                    }
                });
            });
        },
        goSeeCont(e) {
            // TODO: 查看合同详情
            this.$Message.info('查看合同功能待实现')
        },
        goDel(e) {
            this.$Modal.confirm({
                title: '删除提示',
                content: '请问您是否确认删除此条印章申请吗，删除后无法恢复!!!',
                onOk: () => {
                    del_applyrecord({ id: e.id }).then(res => {
                        this.$Message.success(res.msg)
                        this.getList()
                    }).catch(res => {
                        this.$Message.error(res.msg)
                    })
                },
                onCancel: () => {
                }
            });
        },
        requireMsg() {
            examineSeal({ id: this.msgID, status: '2', refuse_reason: this.refuse_reason }).then(res => {
                this.$Message.success(res.msg)
                this.getList()
                this.showMsg = false
                this.refuse_reason = ''
            }).catch(res => {
                this.$Message.error(res.msg)
            })
        },
        agree(e) {
            this.showMore = true
            this.needId = e.id
        },
        requireMore() {
            this.$Modal.confirm({
                title: '操作提示',
                content: '请问您是否确认此用户使用该印章，确认无误后请点击确定按钮。',
                onOk: () => {
                    examineSeal({ id: this.needId, status: '1', is_sms: this.is_sms }).then(res => {
                        this.$Message.success(res.msg)
                        this.getList()
                        this.showMore = false
                    }).catch(res => {
                        this.$Message.error(res.msg)
                    })
                },
                onCancel: () => {
                }
            });
        },
        clearDel(id) {
            this.msgID = id
            this.showMsg = true
        },
        pageChange(index) {
            this.storePrams.page = index
            this.getList()
        }
    }
}
</script>

<style scoped lang="scss">
.seal-page {
    width: 100%;
    min-height: 100%;
    background: #EDF0F9;
    padding: 20px;

    .top_change {
        width: 100%;
        background: #FFFFFF;
        border-radius: 8px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0px 30px;
        box-sizing: border-box;
        height: 60px;

        .l_where {
            font-size: 18px;
            font-family: PingFang SC;
            font-weight: bold;
            color: #1B2742;

            span {
                color: #4877E8;
            }
        }

        .middle_width {
            width: 30%;
            margin: auto;
            display: flex;
            justify-content: space-around;
        }

        .nav_name {
            font-size: 20px;
            font-weight: bold;
            color: #545F78;
            height: 60px;
            line-height: 60px;
            cursor: pointer;
            position: relative;
            padding: 0 20px;

            &:hover {
                color: #4877E8;
            }

            &.active {
                color: #4877E8;

                &:after {
                    content: '';
                    display: inline-block;
                    position: absolute;
                    left: 0;
                    bottom: 0;
                    width: 100%;
                    height: 2px;
                    background: #4877E8;
                    border-radius: 1px;
                }
            }
        }
    }

    .seal-nav {
        width: 100%;
        min-height: 300px;
        padding: 24px;
        box-sizing: border-box;
        border-radius: 8px;
        background: white;
        margin-top: 20px;

        .seal_title {
            font-size: 18px;
            font-weight: bold;
            color: #545F78;
        }

        .choose_style {
            display: flex;
            align-items: center;
            margin-top: 12px;

            .blue {
                margin-right: 20px;
            }
        }

        .haschoose {
            border: 1px solid #4877E8 !important;
            position: relative;
        }

        .right_top {
            position: absolute;
            top: 0;
            right: 0;
            padding: 2px 6px;
            z-index: 11;
            color: #FFFFFF;
            background: linear-gradient(to right, #6884F3 0%, #3E5FE2 100%);
            border-bottom-left-radius: 5px;
        }

        .seal_group {
            display: flex;
            align-items: center;
            flex-wrap: wrap;
            margin-top: 30px;

            .seal_nav_item {
                margin-right: 20px;
                margin-bottom: 20px;

                .seal-img {
                    width: 200px;
                    height: 200px;
                    background: #FFFFFF;
                    border: 1px solid #C8CEDA;
                    border-radius: 6px;
                    overflow: hidden;
                    position: relative;
                    cursor: pointer;

                    img {
                        width: 140px;
                        height: 140px;
                        object-fit: cover;
                    }

                    &:hover .do_it {
                        display: inline-block;
                    }

                    &:hover .do_btn {
                        display: flex;
                    }

                    .do_it {
                        position: absolute;
                        left: 0;
                        top: 0;
                        right: 0;
                        bottom: 0;
                        background: #191A1F;
                        opacity: 0.3;
                        display: none;
                    }

                    .do_btn {
                        display: flex;
                        position: absolute;
                        left: 0;
                        bottom: 0;
                        width: 100%;
                        display: none;

                        .l-icons {
                            flex: 1;
                            height: 40px;
                            background: white;
                            cursor: pointer;

                            &:first-child {
                                border-right: 1px solid #C8CEDA;

                                .iconfont {
                                    color: #4877E8;
                                    font-size: 24px;
                                }
                            }

                            &:last-child {
                                .iconfont {
                                    color: #FD5454;
                                    font-size: 21px;
                                }
                            }
                        }
                    }
                }

                .out_height {
                    width: 70px;
                    height: 34px;
                    margin-top: 10px;
                }

                .use_btn {
                    width: 70px;
                    height: 34px;
                    background: #FFFFFF;
                    border: 1px solid #C8CEDA;
                    border-radius: 4px;
                    font-size: 16px;
                    color: #545F78;
                    cursor: pointer;

                    &:hover {
                        border-color: #4877E8;
                        color: #4877E8;
                    }
                }
            }
        }
    }

    .seal_and_signature {
        width: 320px;
        height: 100px;
    }

    .seal_card {
        width: 360px;
        height: 360px;
        background: white;
        border-radius: 5px;
        flex-direction: column;

        .close {
            position: absolute;
            top: 15px;
            right: 15px;
            cursor: pointer;
        }

        .require_seal {
            width: 220px;
            height: 220px;
            border-radius: 6px;

            img {
                width: 100%;
                height: 100%;
                border-radius: 6px;
            }
        }
    }

    .one_input {
        margin: 32px 8px;
        margin-bottom: 21px;
    }

    .fenbu {
        display: flex;
        justify-content: flex-end;
        gap: 10px;
    }

    // 待审核印章样式
    .page-cont {
        background: white;
        min-height: 700px;
        border-radius: 8px;
        margin-top: 20px;
    }

    .a-table {
        background: white;
        padding: 20px;
    }

    .b_table {
        background: white;
        padding: 30px;
        box-sizing: border-box;
    }

    .new_switch {
        padding-top: 32px;
        margin-left: 30px;
    }

    .new_select {
        width: 200px;
        margin-left: 12px;
        margin-top: 20px;
        padding-left: 20px;
    }

    .cont-cla {
        color: #1A73E8;
        cursor: pointer;
    }

    .input_wrap {
        display: flex;
        align-items: center;
        margin-top: 20px;
    }

    .agree_require {
        display: flex;
        align-items: center;
        margin-top: 40px;
        margin-bottom: 40px;
    }

    .wrap_label {
        font-size: 14px;
        margin-right: 12px;
    }
}

.flex {
    display: flex;
}

.flex-c {
    display: flex;
    align-items: center;
    justify-content: center;
}

.flex-b {
    display: flex;
    justify-content: space-between;
}

.table-btn {
    padding: 8px 16px;
    border-radius: 4px;
    cursor: pointer;
    font-size: 14px;
    border: none;

    &.blue {
        background: #4877E8;
        color: white;
    }

    &.edit {
        background: #FFFFFF;
        border: 1px solid #C8CEDA;
        color: #545F78;
    }

    &.danger {
        background: #FD5454;
        color: white;
        margin-left: 10px;
    }
}

.pop {
    position: fixed;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    z-index: 1000;
}

.fixed {
    position: fixed;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    z-index: 1001;
}

.icon-cla {
    cursor: pointer;
}

.yulan {
    text-align: center;
    font-size: 16px;
    margin-top: 8px;
}

.one_input {
    margin: 32px 8px;
    margin-bottom: 21px;
}

.text_red {
    color: red;
}

.yz_cla {
    width: 304px;
    height: 304px;
    border: 1px solid #4877E8;
}
</style>
